module.exports = __webpack_public_path__ + "media/images/badges/rumble/milestone-100-Inactive-Rumble-76acdf81b5cde64b081c7e8c01abccb3.png";